<script setup lang="ts">
import type { ProgressRootProps } from "reka-ui"
import type { HTMLAttributes } from "vue"
import { reactiveOmit } from "@vueuse/core"
import {
  ProgressIndicator,
  ProgressRoot,
} from "reka-ui"
import { cn } from "@/lib/utils"

const props = withDefaults(
  defineProps<
    ProgressRootProps & {
      class?: HTMLAttributes["class"]
      indeterminate?: boolean;
    }
  >(),
  {
    modelValue: 0,
    indeterminate: false,
  },
)

const delegatedProps = reactiveOmit(props, "class", "indeterminate")
</script>

<template>
  <ProgressRoot
    data-slot="progress"
    v-bind="delegatedProps"
    :class="
      cn(
        'bg-primary/20 relative h-2 w-full overflow-hidden rounded-full',
        props.class,
      )
    "
  >
    <template v-if="indeterminate">
      <div class="bg-primary absolute bottom-0 top-0 animate-indeterminate-long" />
      <div class="bg-primary absolute bottom-0 top-0 animate-indeterminate-short" />
    </template>
    <ProgressIndicator
      v-else
      data-slot="progress-indicator"
      class="bg-primary h-full w-full flex-1 transition-all"
      :style="`transform: translateX(-${100 - (props.modelValue ?? 0)}%);`"
    />
  </ProgressRoot>
</template>
